import React, { useState, useEffect } from "react";
//This line imports the entire React library.
//use state is a hook that has state variable This variable holds the current value of your state.
//and state function This is a special function provided by React that allows you to update the state variable.

//In React, use effect components can do more than just display content. They can also interact with the
// browser environment, such as fetching data from a server, subscribing to events, or changing the document
// title. These actions are known as side effects because they affect things outside of the component itself.(class or functional component)
import { app } from "../../firebase";
//The app object is likely the Firebase app instance initialized with Firebase configuration settings.
import { getFirestore, collection, addDoc, Timestamp, query, where, getDocs } from "firebase/firestore";
//getfirestore function is used to initialize and get a reference to the Firestore database.
// It is typically called once at the beginning of your application to establish a connection to Firestore
//collection function is used to reference a specific collection within the Firestore database. It takes the Firestore
//instance and the name of the collection as arguments and returns a CollectionReference object.
//addDoc: This function is used to add a new document to a Firestore collection
//In Firestore, a timestamp is a special type of data that represents a specific point in time.
// Just like a timestamp on a video or a clock on a wall, it tells you when something happened or should happen.
//Think of a timestamp as a way to mark events or moments in your Firestore database. For example,
// when you add a new document to your
// database, Firestore can automatically add a timestamp to record the exact moment when that document was created or updated.
//query: This function is used to create a query object for retrieving documents from Firestore.
//where: This function is used as a query constraint to filter documents based on certain conditions.
//get docs:This function is used to asynchronously(Asynchronous, in simple terms, refers to tasks or processes
// that happen independently of each other, without waiting for one another to complete. In programming,
// asynchronous operations allow a program to continue
// executing other tasks while waiting for certain operations, such as data fetching, file reading, or network requests,
// to finish) retrieve documents from Firestore based on a query.
import { Modal, Button } from "react-bootstrap";
//This line imports the Modal and Button components from the react-bootstrap library.
// These components are used to create modal dialogs and buttons, respectively.
import image from "../contact/image11.jpg";
import "./Contact.css";
import { getAuth } from "firebase/auth";
//This line imports the getAuth function from the Firebase Authentication module.
const auth = getAuth();
const db = getFirestore(app);
//Initializes Firebase Auth and Firestore instances using the getAuth() and getFirestore() functions respectively.
const Contact = ({ theme }) => {
    //Defines the Contact functional component and destructures the theme prop passed to it.
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [loader, setLoader] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [loadingReplies, setLoadingReplies] = useState(false);
    const [showReplyModal, setShowReplyModal] = useState(false);
    const [messagesSent, setMessagesSent] = useState([]);


    useEffect(() => {
        const user = auth.currentUser;

        if (user) {
            setEmail(user.email);
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        //Prevents the default form submission behavior if users type enter in the text field
        setLoader(true);// sending...

        try {

            const trimmedMessage = message.trim();
            if (trimmedMessage.length === 0) {
                alert("Message cannot be empty.");
                setLoader(false);
                return;
            }
            const messageWordCount = trimmedMessage.split(/\s+/).length;
            if (messageWordCount > 200) {
                alert("Message should not exceed 200 words.");
                setLoader(false);
                return;
            }

            // Query to fetch the user's messages
            const userMessagesQuery = query(collection(db, "contacts"), where("email", "==", email));

            const userMessagesSnapshot = await getDocs(userMessagesQuery);
            const messageCount = userMessagesSnapshot.size;

            const currentTime = Timestamp.now().toMillis();

            const oneHourAgo = currentTime - (60 * 60 * 1000);

            const messagesSentWithinHour = userMessagesSnapshot.docs.filter(doc => {

                const messageTimestamp = doc.data().timestamp.toMillis();

                return messageTimestamp > oneHourAgo;

            });

            if (messagesSentWithinHour.length >= 3) {
                alert("You have exceeded the limit of messages sent in one hour.");
                setLoader(false);
                return;
            }

            // If the conditions are met, add the new message
            await addDoc(collection(db, "contacts"), {
                email: email,
                message: message,
                timestamp: Timestamp.now(),
            });

            //This await statement adds a new document to the Firestore collection named "contacts".
            // It awaits the asynchronous operation of adding the document to Firestore before proceeding further.
            // The document contains three fields: email, message, and timestamp.
            // email and message are retrieved from the component's state variables email and message, respectively.
            // timestamp is set to the current timestamp obtained using Timestamp.now().

            setMessage("");
            setShowModal(true);
        } catch (error) {
            console.error("Error adding document: ", error);
        }

        setLoader(false);
    };

    const handleViewReplies = async () => {
        //async: This keyword is used to define a function as asynchronous. It allows the function to use the
        // await keyword inside it to pause the execution and wait for asynchronous operations to finish.

        // await: This keyword is used inside an async function to pause the execution of the function until
        // a promise (an object representing the eventual completion or failure of an asynchronous operation) is
        // resolved. It allows you to write asynchronous code in a more synchronous-looking way,
        // making it easier to read and understand.
        setLoadingReplies(true);
        setShowReplyModal(true);
        //const handleViewReplies = async () => {: This line defines a function named handleViewReplies
        // using the arrow function syntax (=>). The async keyword before the parentheses indicates that
        // this function is asynchronous, meaning it can perform operations that may take some time to complete.
        try {
            const userMessagesQuery = query(collection(db, "contacts"), where("email", "==", email));
            // This line creates a Firestore query to retrieve documents from the "contacts" collection
            // where the email field matches the user's email address.
            const userMessagesSnapshot = await getDocs(userMessagesQuery);
            //This line asynchronously retrieves the documents matching the query
            // from Firestore and stores them in the userMessagesSnapshot variable.
            // The await keyword pauses the execution of the function until the promise returned by
            // getDocs() is resolved, meaning the data is fetched successfully.
            const userMessages = userMessagesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            //This line maps over the documents in the snapshot, extracting the document IDs and data for each document.
            // It creates an array of objects containing the document ID and data for each document.

            const sortedMessages = userMessages.sort((a, b) => b.timestamp - a.timestamp); // Sort messages by timestamp (recent first)
            //const sortedMessages = userMessages.sort((a, b) => b.timestamp - a.timestamp)
            // userMessages: This is an array containing all the messages retrieved from the Firestore database
            // .sort(): This is a built-in JavaScript method for sorting arrays. It sorts the elements of an array in place
            // and returns the sorted array. By default, the sort() method sorts elements alphabetically or numerically.
            // (a, b) => b.timestamp - a.timestamp: This is a comparison function passed to the sort() method.
            // It determines the sorting order based on the timestamp property of each message object (a and b). Here's how it works:
            // a and b: These are two message objects being compared.
            // a.timestamp and b.timestamp: These are the timestamp properties of the a and b message objects, respectively.
            // b.timestamp - a.timestamp: This expression subtracts the timestamp of message a from the timestamp of message b.
            // If b.timestamp is greater than a.timestamp, the result will be positive, indicating that message b is more recent
            // and should appear before message a in the sorted array.
            // Therefore, the comparison function sorts the messages in descending order of their timestamps,
            // meaning the most recent messages come first in the sorted array.
            // const sortedMessages: This variable stores the sorted array of messages, with the most recent messages
            // appearing at the beginning of the array.
            const groupedMessages = groupMessagesByRepliedMessage(sortedMessages);
            setMessagesSent(groupedMessages);
        } catch (error) {
            console.error("Error fetching user messages:", error);
        }
        setLoadingReplies(false);
    };


    const groupMessagesByRepliedMessage = (messages) => {
        const groupedMessages = {};
        //This object will hold arrays of messages grouped by their replied messages.
        messages.forEach(message => {
            //This line begins a loop that iterates over
            // each message in the messages array. It's a way to process each message individually.
            const repliedMessage = message.replyMessage || "No reply yet";
            //Here, the replyMessage property of the current message is extracted.
            // If the property is empty or does not exist (falsy), it defaults to "No reply yet".
            // This line ensures that we have a value to group the messages by.
            if (!groupedMessages[repliedMessage]) {
                groupedMessages[repliedMessage] = [];
                //This conditional statement checks if there's already an array
                // for the current replied message in groupedMessages. If not,
                // it creates an empty array for that replied message.
            }
            groupedMessages[repliedMessage].push(message);
            //This line adds the current message to the array corresponding
            // to its replied message in the groupedMessages object. It essentially
            // groups the messages by their replied messages.

        });
        // Sort messages by repliedTimestamp in descending order (latest first)
        return Object.entries(groupedMessages).map(([replyMessage, messages]) => ({
            replyMessage,
            messages: messages.sort((a, b) => b.repliedTimestamp - a.repliedTimestamp)
        }));
        //In summary, this line of code converts the grouped messages object into an array of
        // objects, where each object represents a replied message along with its associated messages
        // sorted by their repliedTimestamp.
    };

    return (
        <div className={`container ${theme}`} style={{ minHeight: '100vh', position: 'relative', backgroundImage: `url(${image})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
            <div className="row justify-content-center align-items-center" style={{ minHeight: '100vh', position: 'relative', zIndex: 1 }}>
                <div className="col-md-6 col-lg-4">
                    <div className="card" style={{ backgroundColor: theme === 'light' ? 'white' : 'rgba(0, 0, 0, 0.8)' }}>
                        <div className="card-body">
                            <h2 className="card-title text-center" style={{ color: theme === 'light' ? 'black' : 'white' }}>Get in touch</h2>
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="email" className={theme === 'dark' ? 'text-white' : 'text-dark'}>
                                        Email
                                    </label>
                                    <input
                                        placeholder="Email"
                                        type="email"
                                        name="email"
                                        id="email"
                                        className="form-control"
                                        value={email}
                                        disabled
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="message" className={theme === 'dark' ? 'text-white' : 'text-dark'}>
                                        Message
                                    </label>
                                    <textarea
                                        placeholder="Say Hello"
                                        rows="5"
                                        className="form-control"
                                        name="message"
                                        id="message"
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                        //onchange is the name of the event handler.
                                        // It indicates that the provided function should be called when the value of the input field changes.

                                        //(e): This is the event object that is automatically passed to the event handler by React.
                                        // It contains information about the event that occurred, such as the target element
                                        // (the input field that triggered the event).

                                        //e.target.value: This retrieves the current value of the input field.
                                        // When the user types something into the input field, this value represents the updated content of the input field.

                                        //onChange={(e) => setMessage(e.target.value)} the function is executed when the input changes


                                    ></textarea>
                                </div>
                                <div className="mb-3">

                                    <button
                                        type="submit"
                                        className={`btn btn-secondary btn-block ${theme === 'light' ? "light-mode-button" : ""}`}
                                        style={{ backgroundColor: theme === 'light' ? "black" : "black", color: theme === 'dark' ? "white" : "white", fontWeight: "bold", borderColor: "transparent", marginLeft: "0%" }}
                                        disabled={loader}
                                    >
                                        {loader ? "Sending..." : "Send"}
                                        {/*
                                          In the provided code, the loader variable is used to indicate
                                           whether data is currently being sent or processed.
                                           disabled={loader}: Sets the disabled attribute of the button based on
                                            the loader state variable. If loader is true, the button is disabled; otherwise, it's enabled.

                                            This is a ternary operator inside the button content. If loader is true, it displays "Sending...";
                                             otherwise, it displays "Send". This dynamically changes the button text based on whether data is being sent or not.

                                           */}
                                    </button>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={showReplyModal} onHide={() => setShowReplyModal(false)} centered>
                {/* //<Modal>: This is a component provided by the react-bootstrap library. It creates a modal dialog, a
                popup window that overlays the main content of the page.
                //
                // show={showReplyModal}: This attribute controls whether the modal is visible or not. It takes a
                boolean value stored in the showReplyModal state variable. If showReplyModal is true, the modal is
                shown; if it's false, the modal is hidden.
                //
                // onHide={() => setShowReplyModal(false)}: This attribute specifies the action to be taken when the
                modal is closed. It's a function that sets the showReplyModal state variable to false, effectively
                hiding the modal. This function is executed when the user clicks outside the modal or presses the escape
                key.
                //
                // centered: This attribute centers the modal vertically and horizontally on the screen.
                */}
                <Modal.Header closeButton>
                    <Modal.Title>Replies</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    {loadingReplies ? (
                        <p>Loading replies...</p>
                    ) : (
                        <div>
                            {messagesSent.map((group, index) => (
                                <div key={index}>
                                    {group.messages.map((message, messageIndex) => (
                                        // Within each group, this maps over the messages array to render each individual message along with its content.
                                        <div key={messageIndex}>
                                            <p><strong>Message:</strong> {message.message}</p>
                                        </div>
                                    ))}
                                    <p><strong>Admin's Reply:</strong> {group.replyMessage}</p>
                                    <p>**********************************************************</p>
                                </div>
                            ))}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowReplyModal(false)}>
                        Close
                    </Button>
                    {/*In summary, this button allows users to close the modal by
                    triggering the setShowReplyModal function with false as an argument when clicked.*/}
                </Modal.Footer>
            </Modal>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered>

                {/*show: This prop controls whether the modal is currently displayed or hidden.
                 When set to true, the modal is displayed; when set to false, the modal is hidden.

                 onHide: This prop specifies a function to be called when the modal is closed or hidden.
                  It allows you to define custom behavior when the modal is dismissed by the user.*/}
                <Modal.Header closeButton>
                    <Modal.Title>Success</Modal.Title>
                </Modal.Header>
                <Modal.Body>Your message has been submitted 👍</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            <Button
                className="view-replies-button"
                variant="primary"
                onClick={handleViewReplies}
                style={{
                    position: "fixed",
                    bottom: "20px",
                    right: "20px",
                    backgroundColor: "white",
                    color: "black",
                    zIndex: 1000, // Ensure it's above other content
                    "@media (max-width: 576px)": {
                        bottom: "10px",
                        right: "10px",
                        fontSize: "14px", // Adjust font size for smaller screens if necessary
                        padding: "8px 16px", // Adjust padding for smaller screens if necessary
                    },
                }}
            >
                View Replies
            </Button>


        </div>
    );
};

export default Contact;